export default {
      id: "about-symbols-05-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-05",
      toString: function () {
        return this.url;
      }
    }